var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page text-center" }, [
    _c(
      "h2",
      {
        staticClass: "myTitle hidden-sm-and-down",
        staticStyle: { "margin-bottom": "0" },
      },
      [_vm._v("Anmeldung")]
    ),
    _c("div", { staticClass: "spacer-15" }),
    _c("div", { staticClass: "spacer-15 hidden-md-and-up" }),
    _vm._m(0),
    _c("div", { staticClass: "spacer-25" }),
    _c("div", { staticClass: "spacer-25" }),
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _c(
          "v-btn",
          {
            staticClass: "text-none btn-df",
            nativeOn: {
              "&click": function ($event) {
                return _vm.gotoResetPW.apply(null, arguments)
              },
            },
          },
          [_vm._v("Passwort vergessen? ")]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "spacer-25" }),
    _c(
      "div",
      { staticClass: "text-center" },
      [
        _c(
          "v-btn",
          {
            staticClass: "btn-df",
            nativeOn: {
              "&click": function ($event) {
                return _vm.gotoRegister.apply(null, arguments)
              },
            },
          },
          [
            _c("v-icon", { attrs: { left: "", medium: "" } }, [
              _vm._v("mdi-account-plus"),
            ]),
            _vm._v(" Registrieren "),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "spacer-25" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "uiWrapper" }, [
      _c("div", { staticClass: "loader" }, [
        _c("img", { attrs: { src: require("../assets/icons/loader.gif") } }),
      ]),
      _c("div", { attrs: { id: "firebaseui-auth-container" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }